import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { cache, createQuery, localStorageCache } from '@farfetched/core';
import { signout } from '@features/common';
import { getTypesResidentsImport } from './api';
import type { GetTypesResidentsImportResponse } from './types';

export const TypesResidentsImportGate = createGate();

const fxGetTypesResidentsImport = createEffect<
  void,
  GetTypesResidentsImportResponse,
  Error
>().use(getTypesResidentsImport);

export const typesResidentsImportQuery = createQuery({
  name: 'typesResidentsImport',
  effect: fxGetTypesResidentsImport,
  mapData: ({ result }) =>
    Array.isArray(result?.available_type)
      ? result.available_type.map((item) => ({
          id: item.type,
          label: item?.title,
        }))
      : [],
});

cache(typesResidentsImportQuery, {
  adapter: localStorageCache({ maxAge: '5m' }),
  purge: signout,
});

sample({
  clock: TypesResidentsImportGate.state,
  source: TypesResidentsImportGate.status,
  filter: (status) => Boolean(status),
  target: typesResidentsImportQuery.start,
});
